import { ZapierSession } from '@zapier/universal-layout';
import type { Fetch } from '../../shared/types';
import { Zap } from '../../zapier/types';
import getZDL from '../../zapier/utils/getZDL';
import { ZapReadRecord } from '../types';

interface BatchResponse {
  id: string;
  zap_id: string;
  tasks: Array<string>;
}

export default async function submitBatch(
  fetch: Fetch,
  data: {
    session?: ZapierSession;
    zap?: Zap;
    records: ZapReadRecord[];
    bulkId?: string;
    filter: Record<string, any>;
  }
): Promise<BatchResponse> {
  const { session, zap, records, filter, bulkId } = data;

  if (!session) {
    throw new Error('missing `session`');
  }

  if (!zap) {
    throw new Error('missing `session`');
  }

  if (!bulkId) {
    throw new Error('missing `bulkId`');
  }

  if (!records.length) {
    throw new Error('empty `records`');
  }

  const {
    steps: [readStep],
  } = getZDL(zap);

  return fetch('v1/batches/', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'x-account-id': String(session.currentAccountId),
    },
    body: {
      node: {
        id: Number(readStep.id),
        owner_id: session.customUserId,
        account_id: session.currentAccountId,
        selected_api: readStep.app,
        action: readStep.action,
        authentication_id: readStep.authentication_id,
      },
      bulk_id: bulkId,
      records,
      filter,
    },
  });
}
